import React from 'react'

import { Select, SelectOption } from 'ui/components/Select'

import { useSectionRecordLinksAttributeEditorState } from './hooks/useSectionRecordLinksAttributeEditorState'
import { SectionAttributeEditorProps } from './types'

type SectionRecordLinksAttributeEditorProps = SectionAttributeEditorProps<string[] | string> & {
    record: RecordDto
}

export const SectionRecordLinksAttributeEditor: React.FC<
    SectionRecordLinksAttributeEditorProps
> = ({ label, value, onChange, isReadOnly, field, placeholder, record }) => {
    const {
        localValue,
        handleChange,
        isSingle,
        allOptions,
        searchQuery,
        handleChangeSearchQuery,
        isError,
        isFetching,
        valueOptions,
    } = useSectionRecordLinksAttributeEditorState({
        value,
        onChange,
        field,
        record,
    })

    return (
        <Select
            multiSelect={!isSingle}
            size="m"
            label={label}
            value={localValue}
            onChange={handleChange}
            readOnly={isReadOnly}
            isSearchable={true}
            isClearable={true}
            placeholder={placeholder}
            isLoading={isFetching}
            searchQuery={searchQuery}
            setSearchQuery={handleChangeSearchQuery}
            isError={isError}
            contentProps={{
                style: {
                    maxWidth: 'var(--radix-dropdown-menu-trigger-width)',
                },
            }}
            optionsOverride={valueOptions}
        >
            {allOptions.map((option) => (
                <SelectOption
                    key={option.value}
                    value={option.value}
                    label={option.label}
                    startAvatar={option.startAvatar}
                />
            ))}
        </Select>
    )
}
